export default "__VITE_ASSET__BPzB0XwA__"